import * as React from "react";

/** Presentation/UI */
import { Col, CardText, CardBody, CardImg } from "reactstrap";
import Card from "../../Components/Styled/Card";
import Row from "../../Components/Styled/Row";
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import images from "src/Themes/Images";
import { MdKeyboardArrowLeft } from "react-icons/md";
import StyledButton from "../../Components/Styled/Button";
import Link from "../../Components/Styled/Link";
import colors from "src/Themes/Colors";
import styled from "styled-components";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import PageLoader from "src/Components/PageLoader";
import { getReport } from "src/graphql/queries";
import { RouteComponentProps } from "react-router";

interface IPathParams {
  id: string;
}

type Props = RouteComponentProps<IPathParams> & {
  computedMatch: {
    params: {
      id: string;
    };
  };
};

const Label = styled.label`
  padding: 2px;
  background: ${colors.primary};
  display: block;
`;

const Report = (props: Props) => {
  return (
    <BackendWrapper>
      <Query
        query={gql(getReport)}
        variables={{ limit: 1, id: props.computedMatch.params.id }}
      >
        {({ loading, data }) => {
          if (loading) {
            return <PageLoader />;
          }
          if (!loading && data) {
            const report = data.getReport;
            return (
              <Row>
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <Link
                      to={{
                        pathname: "/consumer/reports"
                      }}
                      color={colors.coal}
                      label={
                        <p style={{ fontSize: "17px" }}>
                          <MdKeyboardArrowLeft size="2em" /> Back
                        </p>
                      }
                    />
                  </Col>
                  <Col sm={12} md={4} lg={4}>
                    <Card height={"100%"} padding={"0px"}>
                      <CardImg height={"100%"} src={images.placeHolder} />
                    </Card>
                  </Col>
                  <Col sm={12} md={8} lg={8}>
                    <Card>
                      <CardBody>
                        <h4>{report.name}</h4>
                        <h5>R {report.price}</h5>
                        {/* TODO get report data */}
                        <CardText>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Etiam sit amet molestie tortor. Cras nec felis
                          vel eros porta congue vel at nunc. Morbi ultrices est
                          a eleifend iaculis. Mauris sit amet purus sed metus
                          dignissim venenatis. Phasellus sit amet pretium justo,
                          in pellentesque eros. Nam eu turpis porta odio
                          malesuada semper ac nec sapien. Nam et ipsum at dolor
                          ornare aliquet facilisis quis risus. Nulla sit amet
                          venenatis diam, a suscipit dui. Integer rutrum nibh in
                          velit vestibulum, et dapibus libero blandit.
                          Suspendisse ac erat commodo, consequat arcu sit amet,
                          accumsan nisl. Curabitur sed egestas eros, in sagittis
                          risus. Praesent at lorem sapien. Morbi nec ultricies
                          justo, gravida ornare quam. Sed sed sagittis elit.
                        </CardText>
                        <Label />
                        <Link
                          to={{
                            pathname: `/consumer/checkout/${report.id}`
                          }}
                          label={
                            <StyledButton
                              type="button"
                              label="Checkout"
                              width="100px"
                              color={colors.snow}
                              background={colors.default}
                              margin="5px"
                            />
                          }
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row paddingTop={"20"}>
                  <Col sm={12} md={12} lg={12}>
                    <Card>
                      <CardBody>
                        <p style={{ fontSize: "15px" }}>DETAILS</p>
                        {/* TODO get actual data from the report once it has been built */}
                        <CardText>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Etiam sit amet molestie tortor. Cras nec felis
                          vel eros porta congue vel at nunc. Morbi ultrices est
                          a eleifend iaculis. Mauris sit amet purus sed metus
                          dignissim venenatis. Phasellus sit amet pretium justo,
                          in pellentesque eros. Nam eu turpis porta odio
                          malesuada semper ac nec sapien. Nam et ipsum at dolor
                          ornare aliquet facilisis quis risus. Nulla sit amet
                          venenatis diam, a suscipit dui. Integer rutrum nibh in
                          velit vestibulum, et dapibus libero blandit.
                          Suspendisse ac erat commodo, consequat arcu sit amet,
                          accumsan nisl. Curabitur sed egestas eros, in sagittis
                          risus. Praesent at lorem sapien. Morbi nec ultricies
                          justo, gravida ornare quam. Sed sed sagittis elit.
                          <br />
                          Morbi mattis, sapien aliquet porta luctus, urna eros
                          pulvinar dui, a vehicula risus leo a purus. Ut
                          placerat non odio id semper. Duis aliquam enim et
                          facilisis dignissim. Fusce vitae ipsum augue. Cras
                          posuere ex non mi tristique, vulputate pharetra orci
                          euismod. Vivamus ut felis malesuada, tempor est eget,
                          convallis turpis. Donec ac nibh id augue volutpat
                          consectetur. Maecenas ultrices odio ac nulla tristique
                          imperdiet. Donec at augue volutpat, tristique massa
                          ac, ultricies nulla. Mauris varius quis eros vitae
                          ultricies. Donec tincidunt, erat quis pretium
                          vestibulum, enim est gravida orci, non porta nisl nunc
                          sit amet ipsum. Fusce eu dui nec sem sodales
                          pellentesque a id libero. Curabitur consequat et
                          sapien in placerat. Maecenas eleifend felis massa, ac
                          iaculis elit venenatis eu. Proin ac dui ullamcorper,
                          vehicula ante vitae, venenatis massa. Class aptent
                          taciti sociosqu ad litora torquent per conubia nostra,
                          per inceptos himenaeos.
                        </CardText>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Row>
            );
          } else {
            return <p>There has been a problem loadin your report</p>;
          }
        }}
      </Query>
    </BackendWrapper>
  );
};

export default Report;



// WEBPACK FOOTER //
// ./src/Containers/Report/index.tsx